module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/@deskproapps/dpat/~/babel-runtime/regenerator/index.js
// module id = ED1s
// module chunks = 0